import styled from 'styled-components';

export const ProductContainer = styled.div`
  width: 100%;
  & .product-line {
    width: 100%;
    border-bottom: solid 1px var(--secondary-color-01-50);
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    margin-left: 1rem;
    padding-bottom: 1rem;
    padding-top: 1rem;
    & .name-and-chips-container {
      width: 22rem;
    }
    & span.product-description {
      font-size: larger;
      font-weight: 600;
    }
    & .hefesto-stepper {
      max-width: 6rem;
    }
    & .delete {
      cursor: pointer;
      & .hefesto-icon--sm {
        margin-left: auto;
        margin-right: auto;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
      }
    }
  }
`;
